export const FETCH_IP_WHITELIST = 'FETCH_IP_WHITELIST';

export const FETCH_IP_WHITELIST_IS_PENDING = 'FETCH_IP_WHITELIST_IS_PENDING';

export const FETCH_IP_WHITELIST_IS_ERROR = 'FETCH_IP_WHITELIST_IS_ERROR';

export const CREATE_IP_WHITELIST = 'CREATE_IP_WHITELIST';

export const CREATE_IP_WHITELIST_IS_PENDING = 'CREATE_IP_WHITELIST_IS_PENDING';

export const CREATE_IP_WHITELIST_IS_ERROR = 'CREATE_IP_WHITELIST_IS_ERROR';

export const UPDATE_IP_WHITELIST = 'UPDATE_IP_WHITELIST';

export const UPDATE_IP_WHITELIST_IS_PENDING = 'UPDATE_IP_WHITELIST_IS_PENDING';

export const UPDATE_IP_WHITELIST_IS_ERROR = 'UPDATE_IP_WHITELIST_IS_ERROR';

export const DELETE_IP_WHITELIST = 'DELETE_IP_WHITELIST';

export const DELETE_IP_WHITELIST_IS_PENDING = 'DELETE_IP_WHITELIST_IS_PENDING';

export const DELETE_IP_WHITELIST_IS_ERROR = 'DELETE_IP_WHITELIST_IS_ERROR';

export const SWITCH_STATUS_IP_WHITELIST = 'SWITCH_STATUS_IP_WHITELIST';

export const SWITCH_STATUS_IP_WHITELIST_IS_PENDING = 'SWITCH_STATUS_IP_WHITELIST_IS_PENDING';

export const SWITCH_STATUS_IP_WHITELIST_IS_ERROR = 'SWITCH_STATUS_IP_WHITELIST_IS_ERROR';

export const SORT = 'SORT_IP_WHITELIST';

export const RESET_REDUCER = 'RESET_IP_WHITELIST';
